import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';

const initialState = {
    data: [],
};

export const fetchSkillType = createAsyncThunk(
    'masters/skillType',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/skill-type`);
            return { success: true, message: "SkillTypes fetched successfully!", data: response?.data?.skillTypes };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const createSkillType = createAsyncThunk(
    'masters/skillType',
    async (formData) => {
        try {
            const response = await myAxios.post(`/masters/skill-type`,  formData);

            return { success: true, message: "Skill Types added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateSkillType = createAsyncThunk(
    'masters/updateSkillType',
    async (formData) => {
        try {
            const response = await myAxios.put(`/masters/skill-type/${formData.skillTypeId}`,  formData);

            return { success: true, message: "Skill Types updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteSkillType = createAsyncThunk(
    'masters/deleteSkillType',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/skill-type/${query.skillTypeId}`);

            return { success: true, message: "Skill Types deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

const skillTypeSlice = createSlice({
    name: 'skillType',
    initialState,
    reducers: {
        clearSkillTypeData: state => {
            state.data = [];
        },
        setSkillTypeData: (state, action) => {
            state.data = action?.payload;
        },
       
    },
});

export const skillTypeReducer = skillTypeSlice.reducer;
export const { clearSkillTypeData, setSkillTypeData } = skillTypeSlice.actions;

export const selectSkillTypeData = (state) => state.skillType.data;
